<div class="flex-column">
    <span class="headline-1 mbs-5 text-primary-darker-title mt-3">
        {{ ('modules.admissions.admissions-modules.template-title' | exp:'':'Pedido de módulo') }}
    </span>
    <div>
        <app-theme-card themeScope="admissions">
            <form [formGroup]="modulesForm">
                <div formArrayName="moduleS" class="pt-1">
                    <div *ngFor="let module of moduleS.controls; let i=index">
                        <div [formGroupName]="i" class="flex-column">
                            <div class="flex-row flex-100 gap-1-5em align-start-center pxs-1">
                                <!-- Module -->
                                <div class="flex-column flex-22">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{('modules.admissions.admissions-modules.module' | exp:'':'Módulo')}} *
                                    </span>
                                    <app-select-searching-input (selected)="this.onSelectModule($event, i)"
                                        [name]="this.MODULE" [nameSearching]="this.MODULE_SEARCHING"
                                        [form]="getModuleSFormGroup(i)" [placeholder]="('modules.admissions.admissions-modules.placeholders.select-module' | exp:'':'Seleccione módulo')"
                                        [elements]="this.modulesFiltered" [calculateId]="this.calculateIdModule"
                                        [calculateName]="this.calculateNameModule"
                                        [placeholderNoValue]="('modules.admissions.admissions-modules.placeholders.no-value' | exp:'':'Sin resultados')"
                                        [placeholderSearching]="('modules.admissions.admissions-modules.placeholders.searching-module' | exp:'':'Buscar módulo...')">
                                    </app-select-searching-input>
                                </div>

                                <!-- Frecuency + Date + Actions -->
                                <div class="flex-column flex-100 ">

                                    <span class="subtitle-3 text-primary-darker mbs-1 flex-1">
                                        {{('modules.admissions.admissions-modules.frecuencia' | exp:'':'Frecuencia')}}
                                    </span>

                                    <div class="flex-row flex-100 gap-1em align-start-center">
                                        <app-number-input class="flex-10" [name]="this.AMOUNT" [minValue]="0"
                                            [form]="getModuleSFormGroup(i)" [placeholder]="''">
                                        </app-number-input>

                                        <span class="flex-5 pbs-5 pls-2">{{('modules.admissions.admissions-modules.por' | exp:'':'por')}}</span>

                                        <!-- Frecuency PERIOD -->
                                        <app-select-input class="flex-20" [noOptionText]="('modules.admissions.admissions-modules.placeholders.no-option' | exp:'':'Sin especificar')"
                                            [name]="this.UNIT" [elements]="this.frequencyUnit"
                                            [form]="getModuleSFormGroup(i)">
                                        </app-select-input>

                                        <app-date-picker [name]="this.FROM_DATE" [form]="getModuleSFormGroup(i)"
                                            [placeholder]="('modules.admissions.admissions-modules.placeholders.desde' | exp:'':'Desde')" class="flex-20">
                                        </app-date-picker>

                                        <app-date-picker [name]="this.TO_DATE" [form]="getModuleSFormGroup(i)"
                                            [placeholder]="('modules.admissions.admissions-modules.placeholders.hasta' | exp:'':'Hasta')" class="flex-20">
                                        </app-date-picker>

                                        <div class="flex-20 align-center-center mbs-4">
                                            <button id="" [matTooltip]="('modules.admissions.admissions-modules.tooltips.borrar' | exp:'':'Borrar')" mat-icon-button [color]="'primary'"
                                               type="button" (click)="this.removeModule(i)">
                                               <mat-icon class="text-primary" outlined>delete_outline</mat-icon>
                                           </button>

                                            <button id="" [matTooltip]="('modules.admissions.admissions-modules.tooltips.agregar' | exp:'':'Agregar')" mat-icon-button [color]="'primary'"
                                               type="button" *ngIf="true" (click)="this.addModule()"
                                               [disabled]="btn_addModule_disabled"
                                               [hidden]="(i+1)==moduleS['controls'].length ? false : true">
                                               <mat-icon>add_circle_outline</mat-icon>
                                           </button>
                                        </div>

                                    </div>
                                <!-- </div> -->

                                <!-- ACTIONS -->
                                <!-- <div class="flex-row flex-10 align-start-center mbs-1"> -->
                                    <!-- Remove module -->
                                    <!-- <div class="flex-column flex-40"> -->

                                    <!-- </div> -->
                                    <!-- Add module -->
                                    <!-- <div class="flex-column flex-40"> -->

                                </div>
                                <!-- </div> -->

                            </div>
                            <!-- Contenido del módulo -->
                            <div class="module-content-card" [class.module-content-card--disabled]="!moduleSelected">
                                <div class="module-content-card__title">{{ 'modules.admissions.admissions-modules.module-content.title' | exp:'':'Contenido del módulo' }}</div>
                                <fieldset class="module-content-card__body" [disabled]="!moduleSelected">
                                    <!-- Prácticas -->
                                    <div class="module-section">
                                        <div class="module-section__header cursor-pointer"
                                            (click)="togglePracticesPanel()">
                                            <span>{{ 'modules.admissions.admissions-modules.module-content.practices' | exp:'':'Prácticas' }}</span>
                                            <mat-icon>
                                                {{ practicesPanelExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                                                }}
                                            </mat-icon>
                                        </div>

                                        @if (practicesPanelExpanded) {
                                        <div class="module-section__body">
                                            @if (getPracticesForModule(i)?.length) {
                                            <div class="module-practices-table-wrap">
                                                <table class="module-practices-table module-practices-table--responsive module-practices-table--practice-name-wide">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">{{ 'modules.admissions.admissions-modules.module-content.practices-table.code' | exp:'':'Código' }}</th>
                                                            <th scope="col">{{ 'modules.admissions.admissions-modules.module-content.practices-table.practice' | exp:'':'Práctica' }}</th>
                                                            <th scope="col">{{ 'modules.admissions.admissions-modules.module-content.practices-table.frecuencia' | exp:'':'Frecuencia' }}</th>
                                                            <th scope="col">{{ 'modules.admissions.admissions-modules.module-content.practices-table.attentions' | exp:'':'Atenciones' }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let p of getPracticesForModule(i)">
                                                            <td data-label="Código">{{ p.code || p.practiceId }}</td>
                                                            <td data-label="Práctica" class="module-practices-table__practice">
                                                                <span class="text-ellipsis">{{ p.name }}</span>
                                                            </td>
                                                            <td data-label="Frecuencia">
                                                                {{ getPracticeFrequencyLabel(p) }}
                                                            </td>
                                                            <td data-label="Atenciones">
                                                                min. {{ p.minAttentions ?? '-' }} máx. {{ p.maxAttentions ?? '-' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="module-items-actions mts-5">
                                                    <button mat-button [color]="'primary'" type="button" class="module-items-edit"
                                                        (click)="openPracticesPickerDialog(i)" [disabled]="!moduleSelected">
                                                        {{('modules.admissions.admissions-modules.module-content.editar-practicas' | exp:'':'Editar prácticas')}}
                                                    </button>
                                                </div>
                                            </div>
                                            } @else {
                                            <div class="module-items-box">
                                                <button mat-button [color]="'primary'" type="button"
                                                    (click)="openPracticesPickerDialog(i)" class="module-section__action"
                                                    [disabled]="!moduleSelected">
                                                    <mat-icon>add_circle_outline</mat-icon>
                                                    <span>{{ 'modules.admissions.admissions-modules.module-content.load-practices' | exp:'':'Cargar prácticas' }}</span>
                                                </button>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <!-- Insumos -->
                                    <div class="module-section">
                                        <div class="module-section__header cursor-pointer"
                                            (click)="toggleSuppliesPanel()">
                                            <span>{{('modules.admissions.admissions-modules.module-content.insumos' | exp:'':'Insumos')}}</span>
                                            <mat-icon>
                                                {{ suppliesPanelExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                                                }}
                                            </mat-icon>
                                        </div>

                                        @if (suppliesPanelExpanded) {
                                        <div class="module-section__body">
                                            @if (getSuppliesForModule(i)?.length) {
                                            <div class="module-practices-table-wrap">
                                                <table class="module-practices-table module-practices-table--responsive">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.code' | exp:'':'Código')}}</th>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.insumo' | exp:'':'Insumo')}}</th>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.proveedor' | exp:'':'Proveedor')}}</th>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.cantidad' | exp:'':'Cantidad')}}</th>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.unidad' | exp:'':'Unidad')}}</th>
                                                            <th scope="col">{{('modules.admissions.admissions-modules.module-content.practice-table.costo-unitario' | exp:'':'Costo unitario')}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let s of getSuppliesForModule(i)">
                                                            <td data-label="Código">{{ s.code || s.practiceId }}</td>
                                                            <td data-label="Insumo">{{ s.name }}</td>
                                                            <td data-label="Proveedor">{{ s.providerName || '-' }}</td>
                                                            <td data-label="Cantidad">{{ s.quantity ?? '-' }}</td>
                                                            <td data-label="Unidad">{{ s.unit || '-' }}</td>
                                                            <td data-label="Costo unitario">
                                                                @if (s.unitCost != null) { $ {{ s.unitCost | number:'1.0-2' }} } @else { - }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="module-items-actions mts-5">
                                                    <button mat-button [color]="'primary'" type="button" class="module-items-edit"
                                                        (click)="openSuppliesPickerDialog(i)" [disabled]="!moduleSelected">
                                                        {{('modules.admissions.admissions-modules.module-content.editar-insumos' | exp:'':'Editar insumos')}}
                                                    </button>
                                                </div>
                                            </div>
                                            } @else {
                                            <div class="module-items-box">
                                                <button mat-button [color]="'primary'" type="button"
                                                    (click)="openSuppliesPickerDialog(i)" class="module-section__action"
                                                    [disabled]="!moduleSelected">
                                                    <mat-icon>add_circle_outline</mat-icon>
                                                    <span>{{ 'modules.admissions.admissions-modules.module-content.load-supplies' | exp:'':'Cargar insumos' }}</span>
                                                </button>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    @if (this.moduleS.length > 0 && this.modulePracticesSelectedByIndex?.size == 0 && this.moduleSuppliesSelectedByIndex?.size == 0) {
                                        <mat-error class="ms">{{ 'modules.admissions.admissions-modules.module-content.no-items' | exp:'':'Se debe cargar al menos una práctica o insumo' }}</mat-error>
                                    }
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </app-theme-card>
    </div>
</div>

<!-- ADD-PRACTICES FORM -->
<ng-template #practicesPickerTemplate>
    <div class="flex-column" [formGroup]="practicesPickerForm">
        <div class="flex-row align-start-center gap-0-5em mbs-2">
            <mat-icon class="text-primary">info</mat-icon>
            <span class="subtitle-4 text-primary">{{
                'modules.admissions.admissions-modules.practices-picker.info' | exp:'':'Agrega una o varias prácticas del módulo al esquema prestacional.' }}</span>
        </div>

        <app-text-searching-input [leftIconClass]="'text-primary'" [leftIcon]="'search'"
            [placeholder]="('modules.admissions.admissions-modules.practices-picker.placeholders.search' | exp:'':'Buscar práctica por nombre o código')"
            [label]="''" (onSearch)="onPracticesPickerSearch($event)">
        </app-text-searching-input>

        <div style="overflow: auto;">
            <table mat-table class="practices-picker-table" [dataSource]="filteredPracticePickerRowVM"
                style="width: 100%;">

                <!-- Master / row check -->
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isAllPickerPracticesSelected()"
                            [indeterminate]="isSomePickerPracticesSelected()"
                            [disabled]="getSelectablePickerPracticesCount() === 0"
                            (change)="toggleAllPickerPractices($event.checked)">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" [formControl]="row.fg.get('selected')">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="practice">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center mls-5">
                            <span class="text-start">{{ ('modules.admissions.admissions-modules.practice-form.subtitle' | exp:'':'Práctica') }}</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-practice-row practice-name-row">
                            <span class="practice-picker-practice__code subtitle-4 text-start">
                                {{ row.fg.get('code')?.value || ('modules.admissions.admissions-modules.sin-codigo' | exp:'':'S/C') }}
                            </span>
                            <span class="practice-picker-practice__name subtitle-4 text-ellipsis text-start"
                                [matTooltip]="row.fg.get('name')?.value">
                                {{ row.fg.get('name')?.value }}
                            </span>
                            @if (isPatientSelfCarePracticePickerRow(row)) {
                            <app-self-care-chip></app-self-care-chip>
                            }
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="frequency">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center">
                            <span class="text-start">{{('modules.admissions.admissions-modules.frecuencia' | exp:'':'Frecuencia')}}</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-frequency-row">
                            <app-number-input class="flex-15" [form]="row.fg" [name]="'frequencyAmount'" [minValue]="1"
                                [maxValue]="1000" [money]="false"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'frequencyAmount')"
                                [placeholder]="('modules.admissions.admissions-modules.placeholders.frecuencia' | exp:'':'Frecuencia')">
                            </app-number-input>
                            <span class="subtitle-4 flex-10">por</span>
                            <app-select-input class="flex-20" [name]="'frequencyUnit'" [form]="row.fg"
                                [placeholder]="('modules.admissions.admissions-modules.placeholders.select-frecuency-unit' | exp:'':'Seleccionar')"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'frequencyUnit')"
                                [elements]="this.frequencyUnit" [calculateId]="calculateIdUnit"
                                [calculateName]="calculateNameUnit">
                            </app-select-input>
                            <app-number-input *ngIf="row.fg.get('restrictionRequiredTime')?.value" class="flex-15"
                                [form]="row.fg" [name]="'allowedHours'" [minValue]="1" [maxValue]="24" [money]="false"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'allowedHours')"
                                [placeholder]="('modules.admissions.admissions-modules.practice-form.frecuency.daily-hours' | exp:'':'Horas diarias')">
                            </app-number-input>
                            <span *ngIf="row.fg.get('restrictionRequiredTime')?.value" class="subtitle-4 flex-20">
                                {{row.fg.get('allowedHours')?.value === 1 ? (('modules.admissions.admissions-modules.practice-form.frecuency.daily-hour' | exp:'':'hora diaria') | lowercase) : (('modules.admissions.admissions-modules.practice-form.frecuency.daily-hours' | exp:'':'horas diarias') | lowercase)}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="attentions">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center">
                            <span class="text-start">{{ 'modules.admissions.admissions-modules.practices-picker.columns.attentions' | exp:'':'Cantidad de atenciones'
                                }}</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-attentions-row">
                            <span class="subtitle-4 flex-10">min.</span>
                            <app-number-input class="practice-picker-attentions__input" [form]="row.fg" class="flex-20"
                                [name]="'minAttentions'" [minValue]="0" [money]="false">
                            </app-number-input>
                            <span class="subtitle-4 flex-10">{{ 'modules.admissions.admissions-modules.practices-picker.max-abbr' | exp:'':'máx.' }}</span>
                            <app-number-input class="practice-picker-attentions__input" [form]="row.fg" class="flex-20"
                                [name]="'maxAttentions'" [minValue]="0" [money]="false">
                            </app-number-input>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="practicePickerDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: practicePickerDisplayedColumns" [formGroup]="row.fg"
                    [class.practice-picker-row--has-error]="isPracticePickerRowWithVisibleErrors(row.fg)">
                </tr>
            </table>
        </div>

        <div class="flex-row align-space-evenly-start gap-1em mts-3">
            <button mat-stroked-button [color]="'primary'" type="button"
                (click)="closePracticesPickerDialog()">{{('common.cancel' | exp:'':'Cancelar')}}</button>
            <button mat-flat-button [color]="'primary'" type="button" (click)="applyPracticesPickerSelection()"
                [disabled]="getSelectedPickerPracticesCount() === 0">
                {{ ('common.cargar' | exp:'':'Cargar') }}
            </button>
        </div>
    </div>
</ng-template>

<!-- ADD SUPPLIES FORM-->
<ng-template #suppliesPickerTemplate>
    <div class="flex-column" *ngIf="suppliesPickerForm" [formGroup]="suppliesPickerForm">
        <app-text-searching-input class="flex-70" [leftIconClass]="'text-primary'" [leftIcon]="'search'"
            [placeholder]="('modules.admissions.admissions-modules.supplies-picker.placeholders.quick-search' | exp:'':'Búsqueda rápida')"
            [label]="('modules.admissions.admissions-modules.supplies-picker.labels.search' | exp:'':'Ingrese el nombre o código del insumo')"
            (onSearch)="onSuppliesPickerSearch($event)">
        </app-text-searching-input>

        <div class="" style="overflow: auto;">
            <table mat-table class="supplies-picker-table" [dataSource]="filteredSuppliesPickerRowVM"
                style="width: 100%">

                <!-- Master / row check -->
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isAllPickerSuppliesSelected()"
                            [indeterminate]="isSomePickerSuppliesSelected()"
                            (change)="toggleAllPickerSupplies($event.checked)">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" [formControl]="row.fg.get('selected')">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="supply">
                    <th mat-header-cell *matHeaderCellDef>{{('modules.admissions.admissions-modules.insumo' | exp:'':'Insumo')}}</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="flex-column">
                            <div class="flex-row">
                                <span class="subtitle-4 flex-30 text-ellipsis text-start"
                                    [matTooltip]="row.fg.get('code')?.value || ('modules.admissions.admissions-modules.sin-codigo' | exp:'':'S/C')">
                                    {{ row.fg.get('code')?.value || ('modules.admissions.admissions-modules.sin-codigo' | exp:'':'S/C') }}
                                </span>
                                <span class="subtitle-4 text-ellipsis flex-70 text-start"
                                    [matTooltip]="row.fg.get('name')?.value">
                                    {{ row.fg.get('name')?.value }}
                                </span>
                            </div>

                            <span
                                *ngIf="!suppliesPickerEditMode && row.fg.get('selected')?.value && isSupplyAlreadyAddedInCaseModuleForPicker(row.fg.get('practiceId')?.value)"
                                class="subtitle-5 text-warn">
                                {{ 'modules.admissions.admissions-modules.supplies-picker.already-added' | exp:'':'Ya está agregado al módulo' }}
                            </span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="provider">
                    <th mat-header-cell *matHeaderCellDef>{{('modules.admissions.admissions-modules.proveedor' | exp:'':'Proveedor')}}</th>
                    <td mat-cell *matCellDef="let row">
                        <app-select-searching-dynamic-input class="" [name]="'providerId'"
                            [nameSearching]="'providerSearching'" [form]="row.fg" [httpGet]="this.getProvidersByName"
                            [calculateId]="this.calculateIdProvider" [calculateName]="this.calculateNameProvider"
                            [defaultValue]="this.supplyPickerDefaultProviders[row.index]"
                            [elements]="this.supplyPickerProvidersOnSelect[row.index]" [placeholder]="('modules.admissions.admissions-modules.placeholders.select-provider' | exp:'':'Seleccionar')"
                            [placeholderNoValue]="('modules.admissions.admissions-modules.placeholders.no-value' | exp:'':'Sin resultados')" [placeholderSearching]="('modules.admissions.admissions-modules.placeholders.searching-provider' | exp:'':'Buscar...')"
                            [noOptionText]="('modules.admissions.admissions-modules.placeholders.no-option-provider' | exp:'':'Sin proveedor')"
                            (selectedWithEntity)="onSupplyPickerProviderSelected(row.fg, $event)">
                        </app-select-searching-dynamic-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>{{('modules.admissions.admissions-modules.cantidad-abbr' | exp:'':'Cant.')}}</th>
                    <td mat-cell *matCellDef="let row">

                        <app-number-input [form]="row.fg" [name]="'quantity'" [minValue]="0" [money]="false">
                        </app-number-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef>{{('modules.admissions.admissions-modules.unidad' | exp:'':'Unidad')}}</th>
                    <td mat-cell *matCellDef="let row">

                        <app-select-input [name]="'unit'" [form]="row.fg" [placeholder]="('modules.admissions.admissions-modules.placeholders.unidad' | exp:'':'Unidad')"
                            [elements]="provisionsUnitOptions" [calculateId]="calculateIdUnit"
                            [calculateName]="calculateNameUnit">
                        </app-select-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="unitCost">
                    <th mat-header-cell *matHeaderCellDef>{{ 'modules.admissions.admissions-modules.supplies-picker.columns.unit-cost' | exp:'':'Costo Unitario' }}</th>
                    <td mat-cell *matCellDef="let row">

                        <app-number-input [form]="row.fg" [name]="'unitCost'" [minValue]="0" [money]="true">
                        </app-number-input>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="supplyPickerDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: supplyPickerDisplayedColumns" [formGroup]="row.fg">
                </tr>
            </table>
        </div>

        <div class="flex-row align-space-evenly-start gap-1em mts-2">
            <button mat-stroked-button [color]="'primary'" type="button" (click)="closeSuppliesPickerDialog()">
                {{('common.cancel' | exp:'':'Cancelar')}}
            </button>
            <button mat-flat-button [color]="'primary'" type="button" (click)="applySuppliesPickerSelection()"
                [disabled]="(!suppliesPickerEditMode && getSelectedPickerSuppliesCount() === 0)">
                <span>{{('common.cargar' | exp:'':'Cargar')}}</span>
            </button>
        </div>
    </div>
</ng-template>